<!--
 * @Author: likk
 * @Date: 2023-09-04 18:02:30
 * @LastEditTime: 2023-09-05 08:46:54
 * @LastEditors: likk
 * @Description: 
-->
<template>
  <router-view />
</template>

<script>
export default {
  name: "GXInfoManage",
};
</script>
